<template>
  <div class="copy-to-clipboard">
    <Icon
      alt="Copy to Clipboard"
      icon="clipboard"
      color="gamma"
      :size="size < 21 ? size : 12"
      v-clipboard:copy="text"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
    >
    </Icon>
    <div v-if="copySuccess" class="copy-to-clipboard-item-success">
      {{ $t("global.copied-to-clipboard") }}
    </div>
    <div v-if="copyError" class="copy-to-clipboard-item-error">
      {{ $t("global.copied-to-clipboard-failed") }}
    </div>
  </div>
</template>

<script>
import Icon from "@/components/display/icon/Icon";
import { ref } from "@vue/composition-api";
export default {
  name: "CopyToClipboard",
  components: { Icon },
  props: {
    text: {
      type: String,
      default: null,
    },
    size: {
      type: Number,
      default: 12,
    },
  },
  setup() {
    const copySuccess = ref(false);
    const copyError = ref(false);

    const onCopy = () => {
      toggle(copySuccess);
    };

    const onError = () => {
      toggle(copyError);
    };

    const toggle = (action) => {
      action.value = !action.value;
      setTimeout(() => (action.value = !action.value), 2000);
    };

    return { copyError, copySuccess, onCopy, onError, toggle };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.copy-to-clipboard {
  display: inline-flex;
  font-size: 0.75rem;

  &:hover {
    cursor: copy;
  }
  .copy-to-clipboard-item-success,
  .copy-to-clipboard-item-error {
    animation-duration: 2000ms;
    transition-timing-function: ease-out;
    position: absolute;
    margin-top: -18px;
  }
  .copy-to-clipboard-item-success {
    animation-name: copy-success;
  }
  .copy-to-clipboard-item-error {
    animation-name: copy-error;
  }
}
</style>
